export function isFile(value: unknown): boolean {
  return (
    (typeof File !== "undefined" && value instanceof File) ||
    (typeof Blob !== "undefined" && value instanceof Blob) ||
    (Array.isArray(value) &&
      value.some((item) => (Object.keys(item).length > 1 ? Object.values(item).some(isFile) : isFile(item))))
  );
}
